import React, { useContext, useEffect, useRef, useState } from 'react';
import { Text, Flex, Icon, Tooltip, IconButton, Menu, MenuButton, MenuList, MenuItem, useDisclosure, Box, Button, Portal } from '@chakra-ui/react';
import { MdArrowForward, MdArrowOutward, MdDevices, MdDragIndicator, MdFace, MdMoreVert, MdOutlineAccountTree, MdOutlineDelete, MdOutlineRoute } from 'react-icons/md';
import ProductProvider from '../../lib/productProvider';
import PersonaProvider from '@/persona/lib/personaProvider';
import PersonaThumbnail from '@/persona/components/personaThumbnail';
import ProductLogo from '../../components/productLogo';
import MoveExperienceInProductToGroupForm from './moveExperienceInProductToGroupForm';
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/modal';
import { ProductPageContext } from '../lib/productPageContext';
import useExperienceApi from '@/experiences/lib/useExperienceApi';
import { ProductContext } from '../../lib/productContext';
import { Link, useNavigate } from 'react-router-dom';
import SharedExperienceTag from '@/components/sharedExperienceTag';
import InsightTags from '../../../insight/components/insightTags';
export default function ExperiencesInProductListItem(props) {
  const {
    refreshExperienceList,
    refreshPersonaList,
    experienceGroupList,
    parentGroup,
  } = useContext(ProductPageContext);
  const {
    productId,
    rights,
  } = useContext(ProductContext);
  const {
    experience
  } = props;
  const [isDeleting, setIsDeleting] = useState(false);
  const [personaList, setPersonaList] = useState(false);
  const [productList, setProductList] = useState(false);
  const [previousExperience, setPreviousExperience] = useState(false);
  const navigate = useNavigate();
  const modalMoveToGroup = useDisclosure();
  const ref1 = useRef(null);
  const [isAdding, setIsAdding] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const experienceApi = useExperienceApi();
  const leaveTheGroup = async () => {
    try {
      await experienceApi.moveExperienceToGroupInProduct(
        productId,
        experience.id,
        parentGroup?.group_id ?? null
      );
      await Promise.all([
        refreshExperienceList(),
        refreshPersonaList()
      ])
      navigate(`/products/${productId}?group-id=${parentGroup?.id || ''}`);
    } catch (error) {
      console.error(error);
    }
  }
  const removeExperienceFromProduct = async () => {
    try {
      setIsDeleting(true);
      
      if (!experience?.products_experiences_id) {
        console.error('❌ Error: products_experiences_id is undefined', experience);
        setIsDeleting(false);
        return;
      }
      
      await experienceApi.removeExperienceFromProduct(experience.products_experiences_id);
      await refreshExperienceList()
      setIsDeleting(false);
    } catch (e) {
      console.error('❌ Error in removeExperienceFromProduct:', e);
      setIsDeleting(false);
    }
  }
  useEffect(() => {
    if (experience) {
      setPreviousExperience(experience);
      if (experience.personas && experience.personas[0] !== null) {
        setPersonaList(experience.personas)
      } else {
        setPersonaList(false)
      }
      if (experience.products && experience.products[0] !== null) {
        setProductList(experience.products)
      } else {
        setProductList(false)
      }
    }
  }, [experience]);
  return (
    <>
      <Flex
        px={3}
        py={2}
        backgroundColor="white"
        role={'group'}
        _hover={{
          background: "background.grey",
        }}
        position={"relative"}
        height={"90px"}
      >
        {rights.can_update && (
          <Flex
            position={"absolute"}
            top="0"
            left={"0"}
            height={"100%"}
            opacity={0}
            _groupHover={{ opacity: '1' }}
            cursor={"grab"}
            py={2}
            pr={3}
          >
            <Icon
              as={MdDragIndicator}
              boxSize={'20px'}
              color={"text.light.grey"}
              mr={2}
            />
          </Flex>
        )}
        <Flex
          flexDirection={"column"}
          flex={1}
        >
          <Flex
            alignItems={"flex-start"}
            mb={1}
          >
            <Icon
              as={MdOutlineRoute}
              boxSize={'15px'}
              mr={2}
              mt={"3px"}
            />
            <Flex flexDirection={"column"}>
              <Text noOfLines={1} >{experience.objective}</Text>
              {(experience?.shared_experiences?.id) && (
                <Flex mt={1}>
                  <SharedExperienceTag 
                    sharedExperienceName={experience?.shared_experience_name} 
                    size="sm"
                  />
                </Flex>
              )}
            </Flex>
          </Flex>
        </Flex>
        <Flex
          flexDirection={"column"}
          alignItems={"flex-end"}
          justifyContent={"space-between"}
          height={"100%"}
        >
          <Flex alignItems={"center"}>
            <Flex flexDirection={"column"} alignItems={"flex-end"}>
              {experience.insights_count && (
                <Flex mb={3}>
                  <InsightTags
                    nbPostiveFeedback={experience.insights_count.positive_count}
                    nbNegativeFeedback={experience.insights_count.negative_count}
                    nbImprovementFeedback={experience.insights_count.improvement_count}
                    nbBehavior={experience.insights_count.behavior_count}
                    nbMotivation={experience.insights_count.motivation_count}
                  />
                </Flex>
              )}
              <Flex alignItems={"center"}>
                <Flex alignItems={"center"} >
                  {(personaList && personaList.length > 0) && (
                    <Flex
                      alignItems={"center"}
                      mr={3}
                    >
                      <Icon
                        as={MdFace}
                        size="20"
                        color="text.medium.grey"
                      />
                      {personaList.map((p, i) => (
                        <Tooltip
                          label={p.name}
                          key={i}
                        >
                          <Link to={`/persona/${p.id}`} onClick={(e) => {
                            e.stopPropagation()
                          }}>
                            <Flex
                              ml={2}
                            >
                              <PersonaProvider
                                personaId={p.id}
                                originalPersona={p}
                                needRights={false}
                                needRole={false}
                                needEditionRequest={false}
                              >
                                <PersonaThumbnail
                                  size={20}
                                  hasAcronym={true}
                                />
                              </PersonaProvider>
                            </Flex>
                          </Link>
                        </Tooltip>
                      ))}
                    </Flex>
                  )}
                </Flex>
                {(productList && productList.length > 0) && (
                  <Flex alignItems={"center"}>
                    <Icon
                      as={MdDevices}
                      size="20"
                      color="text.medium.grey"
                    />
                    {productList && productList.map((p, i) => (
                      <Tooltip
                        label={p.name}
                        key={i}
                      >
                        <Link to={`/products/${p.id}`} onClick={(e) => {
                          e.stopPropagation()
                        }}>
                          <Flex
                            ml={2}
                          >
                            <ProductProvider
                              productId={p.id}
                              orignalProduct={p}
                              needRights={false}
                              needRole={false}
                              needEditionRequest={false}
                            >
                              <ProductLogo
                                size={20}
                                hasAcronym={true}
                              />
                            </ProductProvider>
                          </Flex>
                        </Link>
                      </Tooltip>
                    ))}
                  </Flex>
                )}
              </Flex>
            </Flex>
            <Flex
              ml={3}
              alignItems={"center"}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              {!rights.can_update &&
                <IconButton
                  icon={<MdArrowForward />}
                  fontSize={"18px"}
                  size="md"
                  variant='greyTransparent'
                  opacity={"0"}
                  _groupHover={{ opacity: '1' }}
                  onClick={(e) => {
                    navigate(`/experiences/${experience.id}`, { replace: true });
                  }}
                />
              }
              {rights.can_update &&
                <Menu >
                  {({ isOpen }) => (
                    <>
                      <MenuButton
                        isActive={isOpen}
                        as={IconButton}
                        icon={<MdMoreVert />}
                        fontSize={"18px"}
                        size="md"
                        variant='greyTransparent'
                      />
                      <Portal>
                        <MenuList zIndex="popover">
                          <MenuItem onClick={(e) => {
                            navigate(`/experiences/${experience.id}`, { replace: true });
                          }} >
                            <Icon as={MdArrowForward} mr={2} color="text.medium.dark" />
                            <Text color="text.medium.dark">Go to Experience</Text>
                          </MenuItem>
                          {(experienceGroupList && experienceGroupList.length > 0) && !experience.shared_experiences?.id&&
                            <MenuItem onClick={modalMoveToGroup.onOpen} >
                              <Icon as={MdArrowOutward} mr={2} color="text.medium.dark" />
                              <Text color="text.medium.dark"> Move to Group</Text>
                            </MenuItem>
                          }
                          {experience.product_experience_group_id &&
                            <MenuItem
                              onClick={leaveTheGroup}
                            >
                              <Icon as={MdArrowOutward} mr={2} color="text.medium.dark" />
                              <Text color="text.medium.dark">Leave the group</Text>
                            </MenuItem>
                          }
                          {!experience.shared_experiences?.id && (
                            <MenuItem onClick={removeExperienceFromProduct} >
                              <Icon as={MdOutlineDelete} mr={2} color="text.medium.red" />
                              <Text color="text.medium.red">Remove from Product</Text>
                            </MenuItem>
                          )}
                        </MenuList>
                      </Portal>
                    </>
                  )}
                </Menu>
              }
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      <Modal isOpen={modalMoveToGroup.isOpen} onClose={modalMoveToGroup.onClose}>
        <ModalOverlay />
        <ModalContent >
          <ModalHeader>Move to Group</ModalHeader>
          <ModalBody >
            <Box p={3}>
              <MoveExperienceInProductToGroupForm
                productId={productId}
                experienceId={experience.id}
                hideSave={true}
                onValidityChange={setIsValid}
                onSubmitting={() => {
                  setIsAdding(true);
                }}
                onSubmitted={() => {
                  setIsAdding(false);
                  Promise.all([
                    refreshExperienceList(),
                    refreshPersonaList()
                  ])
                  modalMoveToGroup.onClose();
                }}
                ref={ref1}
              />
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="purpleOutline"
              onClick={modalMoveToGroup.onClose}
            >Cancel</Button>
            <Button
              variant="purpleFill"
              ml={2}
              isLoading={isAdding}
              isDisabled={!isValid}
              onClick={() => {
                ref1.current.click();
              }}>Save</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
